<common-confirm></common-confirm>


<h1 class="container-heading">Users roles List</h1>

<mat-card>
    <mat-card-content>

        <common-table *ngIf="listTable" [options]="listTable" (action)="handleListAction($event)">
            <div data-actions>
                <a *userAllowed="'add_users'" routerLink="add" mat-raised-button color="primary"
                   class="create">Add</a>
            </div>
        </common-table>

    </mat-card-content>
</mat-card>